export const pattern = (value, regexp) => {
    if (!regexp.test(value)) {
        return 'Это поле обязательно для заполнения';
    }
    return null;
};
